import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Divider, InputAdornment } from '@material-ui/core'
import { TextField } from '@prototype'
import PfSubPfMultiSelect from '@select/pf-sub-pf-multi-select'
import cloneDeep from 'lodash.clonedeep'

const initialState = {
    dialogType: 'add',
    proprietorID: -1,
    name: '',
    commission: 0,
    filterPfSubPfIDList: [],
    dialogOpen: false,
}

class FinanceReconciliationDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'FinanceReconciliationDialog', options)
        }

        this.state = initialState
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    OpenDialog(dialogType, proprietorList, proprietorID) {
        var filterPfSubPfIDList = []

        switch (dialogType) {
            case 'add':
                proprietorList.forEach((elem) => {
                    if (elem['pf_sub_pf_id_list']) {
                        filterPfSubPfIDList.push(...elem['pf_sub_pf_id_list'])
                    }
                })

                this.setState(
                    {
                        ...initialState,
                        filterPfSubPfIDList: filterPfSubPfIDList,
                    },
                    () => {
                        setTimeout(() => {
                            this.pfSelect.setState({
                                pfSubPfIDList: [],
                            })
                        })
                    }
                )

                break
            case 'edit':
                var proprietorInfo = cloneDeep(proprietorList.find((elem) => elem['id'] === proprietorID))
                proprietorInfo['commission_info'] = JSON.parse(proprietorInfo['commission_info'])
                var curPfSubPfIdMap = {}

                proprietorInfo['pf_sub_pf_id_list'].forEach((elem) => (curPfSubPfIdMap[elem] = true))

                proprietorList.forEach((elem) => {
                    if (elem['pf_sub_pf_id_list']) {
                        elem['pf_sub_pf_id_list'].forEach((pfSubPfId) => {
                            if (true === curPfSubPfIdMap[pfSubPfId]) {
                                // Do nothing
                            } else {
                                filterPfSubPfIDList.push(pfSubPfId)
                            }
                        })
                    }
                })

                this.setState(
                    {
                        ...initialState,
                        proprietorID: proprietorInfo['id'],
                        name: proprietorInfo['name'],
                        commission: proprietorInfo['commission_info'].pop()['commission'],
                        filterPfSubPfIDList: filterPfSubPfIDList,
                    },
                    () => {
                        setTimeout(() => {
                            this.pfSelect.setState({
                                currencyDisabled: true,
                                currency: `${utils.getPfSubPfCurrency(proprietorInfo['pf_sub_pf_id_list'][0])}`,
                                pfSubPfIDList: proprietorInfo['pf_sub_pf_id_list'],
                            })
                        })
                    }
                )

                break
            default:
        }

        this.setState({
            dialogType: dialogType,
            dialogOpen: true,
        })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        switch (this.state.dialogType) {
            case 'add':
                utils.apiRequest(
                    'post',
                    API.PROPRIETOR,
                    {
                        name: this.state.name,
                        commission: this.state.commission,
                        pf_sub_pf_id_list: this.pfSelect.state.pfSubPfIDList,
                    },
                    (_data) => {
                        if (this.props.confirmCallback) {
                            this.props.confirmCallback()
                        }
                        this.closeDialog()
                    }
                )
                break

            case 'edit':
                utils.apiRequest(
                    'put',
                    API.PROPRIETOR,
                    {
                        id: this.state.proprietorID,
                        name: this.state.name,
                        commission: this.state.commission,
                        pf_sub_pf_id_list: this.pfSelect.state.pfSubPfIDList,
                    },
                    (_data) => {
                        if (this.props.confirmCallback) {
                            this.props.confirmCallback()
                        }
                        this.closeDialog()
                    }
                )
                break
            default:
        }
    }

    render() {
        return (
            <Dialog maxWidth="sm" fullWidth open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>{this.t('Title', { dialogType: this.t(this.state.dialogType) })}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <TextField
                                label={this.t('name')}
                                value={this.state.name}
                                onChange={(event) =>
                                    this.setState({
                                        name: event.target.value,
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={8} />
                        <Grid item xs={4}>
                            <TextField
                                label={this.t('commission')}
                                value={this.state.commission}
                                type="number"
                                onChange={(event) => {
                                    let val = parseFloat(event.target.value)
                                    if (val > 100) val = 100
                                    else if (val < 0 || !val) val = 0
                                    this.setState({
                                        commission: val,
                                    })
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                }}
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <div style={{ marginTop: '16px' }}>{this.t('commissionWarningMsg1')}</div>
                            <div style={{ color: 'red' }}>{this.t('commissionWarningMsg2')}</div>
                        </Grid>
                        <Grid item xs={12}>
                            <PfSubPfMultiSelect onRef={(ref) => (this.pfSelect = ref)} filterPfSubPfIDList={this.state.filterPfSubPfIDList} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.confirm()
                        }}
                        color="primary">
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {}
}

FinanceReconciliationDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
    auth: PropTypes.object,
}

export default hoc(styles)(FinanceReconciliationDialog)
